import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import { InlineWidget } from "react-calendly";

import iconClose from "src/Assets/iconography/close.svg";

function CalendlyModal({ open, setOpen }) {
  const calendlyUrl = "https://calendly.com/muycoach/muycoach-demo";

  useEffect(() => {
    if (open) {
      // Inyectar estilos CSS globales muy agresivos para eliminar todo el padding
      const style = document.createElement("style");
      style.id = "calendly-modal-styles";
      style.textContent = `
        .calendly-modal-container {
          padding: 0 !important;
          margin: 0 !important;
        }
        .calendly-inline-widget {
          min-width: 100% !important;
          height: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        .calendly-inline-widget iframe {
          width: 100% !important;
          height: 100% !important;
          border: none !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        /* Intentar eliminar padding interno del contenido de Calendly */
        .calendly-badge {
          display: none !important;
        }
      `;
      document.head.appendChild(style);

      return () => {
        const existingStyle = document.getElementById("calendly-modal-styles");
        if (existingStyle) {
          document.head.removeChild(existingStyle);
        }
      };
    }
  }, [open]);

  return (
    <Dialog
      onClose={() => setOpen(false)}
      open={open}
      fullWidth={true}
      maxWidth={false}
      PaperProps={{
        style: {
          height: "auto",
          maxHeight: "95vh",
          width: "auto",
          maxWidth: "1200px",
          margin: "0",
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
      sx={{
        "& .MuiDialog-container": {
          alignItems: "center",
          padding: "8px",
        },
        "& .MuiDialog-paper": {
          margin: "0 !important",
          backgroundColor: "transparent !important",
          boxShadow: "none !important",
        },
        "& .MuiDialogContent-root": {
          padding: "0 !important",
          margin: "0 !important",
          backgroundColor: "transparent !important",
        },
      }}
    >
      <DialogContent
        className="calendly-modal-container"
        style={{
          padding: 0,
          margin: 0,
          height: "100%",
          width: "100%",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 1000,
          }}
        >
          <IconButton
            onClick={() => setOpen(false)}
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              padding: "4px",
            }}
          >
            <img
              src={iconClose}
              alt="Cerrar"
              className="w-6 h-auto"
            />
          </IconButton>
        </div>
        <div
          style={{
            height: "90vh",
            minHeight: "800px",
            width: "95vw",
            maxWidth: "1200px",
            overflow: "hidden",
            margin: 0,
            padding: 0,
          }}
        >
          <InlineWidget
            url={calendlyUrl}
            styles={{
              height: "100%",
              minHeight: "800px",
              width: "100%",
            }}
            pageSettings={{
              backgroundColor: "ffffff",
              hideEventTypeDetails: false,
              hideLandingPageDetails: false,
              primaryColor: "00a2ff",
              textColor: "4d5055",
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default CalendlyModal;
